// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__arTE","clickable":"styles_clickable_niSWq","content":"styles_content_c1LHq"};